import React, { useState, useMemo } from "react";

export const ProviderSelect = ({ providers, selectedProviderId, onChange }) => {
  // Find the full provider object that is currently selected
  const selectedProvider = useMemo(() => {
    return providers.find((p) => p.provider_id === selectedProviderId);
  }, [providers, selectedProviderId]);

  return (
    <div className="dropdown">
      <button
        className="btn btn-light border provider-select-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selectedProvider ? (
          <span className="provider-option-name">
            {selectedProvider.provider_name}
          </span>
        ) : (
          <span className="provider-select-toggle-placeholder">
            -- Select New Provider --
          </span>
        )}
      </button>
      <ul className="dropdown-menu provider-dropdown-menu">
        {providers.map((provider) => (
          <li key={provider.provider_id}>
            <button
              className="dropdown-item provider-option"
              type="button"
              onClick={() => onChange(provider.provider_id)}
              // This title attribute provides the simple hover info
              title={`Title: ${provider.title || "N/A"}\nExperience: ${
                provider.experience || "N/A"
              }`}
            >
              <img
                src={provider.img_url || "https://via.placeholder.com/40"}
                alt={provider.provider_name}
                className="provider-option-avatar"
              />
              <div className="provider-option-info">
                <div className="provider-option-name">
                  {provider.provider_name}
                </div>
                <div className="provider-option-title">
                  {provider.title || "N/A"}
                </div>
              </div>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
